export class SessionStorage {
	private static data: Record<string, any> = {};

	public static set(name: string, value: string): void {
		SessionStorage.data[name] = value;

		try {
			if (window.sessionStorage) {
				window.sessionStorage.setItem(name, value);
			}
		} catch (e) {
			// NOTE: Ha nincs ilyen funkció akkor nem használjuk
		}
	}

	public static get(name: string): string {
		try {
			if (window.sessionStorage) {
				return window.sessionStorage.getItem(name);
			}
		} catch (e) {
			// NOTE: Ha nincs ilyen funkció akkor nem használjuk
		}

		return SessionStorage.data[name];
	}

	public static remove(name: string): void {
		SessionStorage.data[name] = undefined;

		try {
			if (window.sessionStorage) {
				window.sessionStorage.removeItem(name);
			}
		} catch (e) {
			// NOTE: Ha nincs ilyen funkció akkor nem használjuk
		}
	}
}
